import React from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Loadable, If } from "components/support";
import Icon from "material-ui-next/Icon";
import Dropzone from "react-dropzone";
import styles from "./styles";

const labels = {
  valid: "trocar o .xml",
  absent: "anexar o .xml",
  invalid: "anexar um .xml válido"
};

const placeholders = {
  valid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderValid }}>
      <Icon style={styles.placeholderValidIcon}>done</Icon>
      <span>Arquivo XML válido!</span>
    </div>
  ),
  absent: (
    <div style={styles.placeholder}>
      <Icon style={styles.placeholderIcon}>warning</Icon>
      <span>Você ainda não enviou o arquivo XML.</span>
    </div>
  ),
  invalid: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon style={styles.placeholderInvalidIcon}>not_interested</Icon>
      <span>Ops! Esse arquivo é inválido. Tente novamente.</span>
    </div>
  ),
  in_progress: (
    <div style={{ ...styles.placeholder, ...styles.placeholderInvalid }}>
      <Icon style={styles.placeholderInvalidIcon}>not_interested</Icon>
      <span>Já existe uma importação em andamento</span>
    </div>
  )
};

const BatchDropzone = ({ loading, status, onFileSelect, progress }) => (
  <Paper elevation={1} className="p-sm mb-md">
    <Loadable loading={loading}>
      <Typography type="headline">1ª Etapa - Enviar XML</Typography>

      <Dropzone onDrop={onFileSelect} style={styles.outer} multiple={false}>
        <div style={styles.inner}>
          <div style={styles.placeholderContainer}>{placeholders[status]}</div>
          <If test={progress}>{progress}%</If>
          <If test={!progress}>
            <span>Clique aqui para {labels[status]}</span>
            <span>ou arraste o arquivo até aqui.</span>
          </If>
        </div>
      </Dropzone>
    </Loadable>
  </Paper>
);

export default BatchDropzone;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/modify/xml/dropzone/index.js